import { defineStore } from 'pinia';
import { v4 as uuid } from 'uuid';
import { ESeonStatus, type ISeonResponse } from '~/types/seon';
import { scriptLoader } from '~/utils/scriptLoader';
import { http } from '../transport/http';
import type { IHttpRequestOptions } from '~/types/transport/http';

export const useStoreSeon = defineStore('seon', {
  actions: {
    async loadSeonJSAgent() {
      try {
        await scriptLoader('https://cdn.seondf.com/js/v5/agent.js', 'seondf');
      } catch (e) {
        console.error(e);
      }
    },
    configureSeon() {
      try {
        // @ts-ignore
        window.seon.config({
          host: 'seondf.com',
          session_id: uuid(),
          audio_fingerprint: true,
          canvas_fingerprint: true,
          webgl_fingerprint: true,
          max_proxy_delay: 1000,
        });
      } catch (e) {
        console.error(e);
      }
    },
    async checkIfFraudEmailWithSeon(email: string) {
      try {
        // @ts-ignore
        const session: string = await window.seon.getBase64Session();
        const response: ISeonResponse = await http().post(null, {
          url: '/seon',
          payload: { email, session },
        } as IHttpRequestOptions);

        return response.data.state === ESeonStatus.decline;
      } catch (e) {
        console.info(e);

        return false;
      }
    },
  },
});
